/**
 * @generated SignedSource<<ab82c688b4f8bba5105cd5cb675a7ec2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivitySource = "CABANA" | "SIPGATE" | "STRIPE" | "ZAMMAD" | "%future added value";
export type ActivityPanelCustomerAccountQuery$variables = {
  customerAccountIdentifier: string;
  first?: number | null | undefined;
};
export type ActivityPanelCustomerAccountQuery$data = {
  readonly customerAccountActivities: {
    readonly activities: ReadonlyArray<{
      readonly actorName: string | null | undefined;
      readonly body: string | null | undefined;
      readonly id: string;
      readonly metadata: any;
      readonly occurredAt: any;
      readonly source: ActivitySource;
      readonly type: string;
    }>;
    readonly hasMore: boolean;
  };
};
export type ActivityPanelCustomerAccountQuery = {
  response: ActivityPanelCustomerAccountQuery$data;
  variables: ActivityPanelCustomerAccountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerAccountIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerAccountIdentifier",
        "variableName": "customerAccountIdentifier"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ActivityResult",
    "kind": "LinkedField",
    "name": "customerAccountActivities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metadata",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivityPanelCustomerAccountQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivityPanelCustomerAccountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "822e971f76d2cf3fd9fae614418b490c",
    "id": null,
    "metadata": {},
    "name": "ActivityPanelCustomerAccountQuery",
    "operationKind": "query",
    "text": "query ActivityPanelCustomerAccountQuery(\n  $customerAccountIdentifier: ID!\n  $first: Int\n) {\n  customerAccountActivities(customerAccountIdentifier: $customerAccountIdentifier, first: $first) {\n    activities {\n      id\n      source\n      type\n      occurredAt\n      metadata\n      actorName\n      body\n    }\n    hasMore\n  }\n}\n"
  }
};
})();

(node as any).hash = "f53d041eeb1c91c6a39a8828a6c9abfa";

export default node;
